import { render } from "./CustomerReturn.vue?vue&type=template&id=040b1c5e"
import script from "./CustomerReturn.vue?vue&type=script&lang=js"
export * from "./CustomerReturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__